var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sj-question-file-item sj-question-file-add"},[_vm._t("default",[_c('el-button',_vm._g({attrs:{"type":"text","icon":_vm.icon,"disabled":_vm.disabled}},_vm.$listeners))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4501a3c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/question-editor/packages/sj-question-file/src/SjQuestionFileAdd.vue
// module id = 1758
// module chunks = 5 6 7 18